import { createAsyncThunk } from '@reduxjs/toolkit';
import { userApi } from '~/apis/user';
import {
  GET_PROFILE,
  GET_STUDENT,
  GET_STUDENT_DISCUSSION_FORUMS,
  GET_STUDENT_EXAMS,
  GET_STUDENT_VIDEO_LECTURES,
  UPDATE_PROFILE,
  UPDATE_USERS,
} from '~/utils/constants/actionType';
import { IPayloadUpdateUsers, IQueryGetStudent } from '~/utils/interface/account';
import { IQueryGetStudentProgressPage } from '~/utils/interface/studentProgress';

export const getProfile = createAsyncThunk(GET_PROFILE, async (_, { rejectWithValue }) => {
  try {
    const res = await userApi.getProfile();
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const updateProfile = createAsyncThunk(UPDATE_PROFILE, async (body: FormData, { rejectWithValue }) => {
  try {
    const res = await userApi.updateProfile(body);
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getStudents = createAsyncThunk(GET_STUDENT, async (payload: IQueryGetStudent, { rejectWithValue }) => {
  try {
    const res = await userApi.getStudents(payload);
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const updateUsers = createAsyncThunk(UPDATE_USERS, async (payload: IPayloadUpdateUsers, { rejectWithValue }) => {
  try {
    const res = await userApi.updateUsers(payload);
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getStudentVideoLectures = createAsyncThunk(
  GET_STUDENT_VIDEO_LECTURES,
  async (payload: { studentId: string } & IQueryGetStudentProgressPage, { rejectWithValue }) => {
    try {
      const { studentId, ...query } = payload;
      const res = await userApi.getStudentVideoLectures(studentId, query);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getStudentDiscussionForums = createAsyncThunk(
  GET_STUDENT_DISCUSSION_FORUMS,
  async (payload: { studentId: string } & IQueryGetStudentProgressPage, { rejectWithValue }) => {
    try {
      const { studentId, ...query } = payload;
      const res = await userApi.getStudentDiscussionForums(studentId, query);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getStudentExams = createAsyncThunk(
  GET_STUDENT_EXAMS,
  async (payload: { studentId: string } & IQueryGetStudentProgressPage, { rejectWithValue }) => {
    try {
      const { studentId, ...query } = payload;
      const res = await userApi.getStudentExams(studentId, query);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
